import { useMemo } from 'react'
import { trackUserEvent } from '@vend/utilities'
import { selectCurrentSale } from '../../../state/slices/currentSale/currentSaleSlice'
import { isQuote } from '../../../functions/sale'
import { WEB_REGISTER } from '../../web-register.constant'
import { print } from '../../print/print'
import {
  useRegisterManager,
  useSaleManager,
  useTrainingModeManager,
} from '../../../ng-compat/hooks'
import { useAppSelector } from '../../../state/hooks'

type ReceiptType = 'print' | 'gift'

interface PrintReceiptParams {
  type?: ReceiptType
  receiptTemplateId?: string
  defaultTemplate?: boolean
}

export const usePrintReceipt = () => {
  const register = useRegisterManager().getActiveRegister()
  const trainingModeManager = useTrainingModeManager()
  const saleManager = useSaleManager()
  const sale = useAppSelector(selectCurrentSale)

  const printReceipt = useMemo(
    () => async (
      { receiptTemplateId, defaultTemplate, type }: PrintReceiptParams = {
        type: 'print',
      }
    ) => {
      if (
        !register.print_receipt ||
        trainingModeManager.trainingModeEnabled ||
        isQuote(sale.status)
      ) {
        return
      }

      trackUserEvent(WEB_REGISTER.DISPLAY_NAME, 'Print Receipt Clicked', {
        default_template: defaultTemplate !== false,
        sale_id: sale.localId,
        sale_status: sale.status,
        template_id: receiptTemplateId,
      })

      const data = await saleManager.getReceiptData()
      if (receiptTemplateId) {
        data.selectedReceiptId = receiptTemplateId
      }

      return await print({
        type:
          type === 'gift'
            ? 'styled-gift-receipt'
            : 'receipt-settings-and-template',
        data,
      })
    },
    [
      register.print_receipt,
      sale.localId,
      sale.status,
      saleManager,
      trainingModeManager.trainingModeEnabled,
    ]
  )

  return printReceipt
}
